import { Gondor } from "../Gondor";

const ACTIONS = {
  INVESTMENT: "/investment/",
  INVESTMENT_ITEM: "/investment/{id}/",
  ADD_SYSTEMS: "/investment/add/system",
  REMOVE_SYSTEMS: "/investment/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.INVESTMENT, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.INVESTMENT_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.INVESTMENT, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.INVESTMENT_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.INVESTMENT_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
